import {Component, computed, input} from '@angular/core';
import {AiProvenanceView} from '@frontend/shared-api';

@Component({
  selector: 'app-ai-generated-label',
  templateUrl: './ai-generated-label.component.html',
})
export class AiGeneratedLabelComponent {
  readonly provenance = input<AiProvenanceView | undefined>();

  protected readonly isVisible = computed(() => !!this.provenance()?.aiGenerated);
  protected readonly tooltip = computed(() => {
    const provenance = this.provenance();
    if (!provenance) {
      return '';
    }
    return `${provenance.markingStandard} · ${provenance.provider}`;
  });
}
